import vueConfig from '../../../../../vue.config.js'
const getBlankUrl = (type, {
  procKey,
  startAfter,
  startBefore
}) => {
  let url = `${vueConfig.publicPath}/#`
  const [my, deptManage, deptInvolved] = ['/workflow/personalList', '/workflow/deptManageList', '/workflow/deptInvolveList']
  switch (type) {
    case 'deptManage':
      url += deptManage
      break
    case 'deptInvolved':
      url += deptInvolved
      break
    case 'myApplication':
      url += my
      break
    case 'myTodo':
      url += my
      break
    default:
      url += deptManage
  }
  url += `?processDefinitionKey=${procKey}&start=${startAfter}&end=${startBefore}`
  return url
}

export {
  getBlankUrl
}
